import React from "react";
import { ListSelectProps } from "./interfaces";

const ListSelect: React.FC<ListSelectProps> = (props) => {
  const { items, open, minWidth, onChange } = props;

  return open ? (
    <div
      className="z-[300] mt-2 max-h-[700px] overflow-y-auto rounded-md border border-gray-200 bg-white text-sm font-medium text-gray-900"
      style={{ minWidth: minWidth ? `${minWidth}px` : "176px" }}
    >
      <div className="px-1 py-1.5 hover:z-[300]">
        {items.map((item, index) => (
          <button
            key={index}
            className={`z-[300] flex w-full items-center gap-2 rounded-md bg-white px-3 py-2 text-left transition-colors hover:outline-none disabled:pointer-events-none disabled:opacity-50 ${
              item.type !== "danger"
                ? "hover:bg-gray-100 hover:text-gray-900"
                : "hover:bg-danger/10 hover:text-danger"
            }`}
            disabled={item.disabled}
            onClick={() => onChange?.(item)}
          >
            {item.icon && (
              <item.icon
                className={`h-4 w-4 ${
                  item.name.toLowerCase().includes("pdf")
                    ? "stroke-red-600"
                    : item.name.toLowerCase().includes("excel")
                      ? "stroke-green-600"
                      : item.iconColor || ""
                }`}
              />
            )}
            <span className="text-sm font-normal">{item.name}</span>
          </button>
        ))}
      </div>
    </div>
  ) : null;
};

export default ListSelect;
